import request from "@/utils/requestSC";

// 获取一级分类
export async function getCategoryOneList() {
  return request.get("/rest/category/queryCategoryOneList");
}

// 获取二级分类
export async function getCategoryTwoList(params) {
  return request.get("/rest/category/queryCategoryTwoList", { params });
}

// 获取商品列表
export async function getCategoryGoodsList(params) {
  return request.get("/rest/category/queryGoodsListByCategory", { params });
}
